var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-input',{attrs:{"value":_vm.display},on:{"input":_vm.change,"change":_vm.update,"focus":function($event){return _vm.$emit('focus', true)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }